const CTAFinal = () => {
  return (
    <section className="bg-[#1E0750] py-16 px-8 lg:px-16">
      <div className="max-w-[640px] mx-auto text-center">
        <div className="text-[#A3E635] font-bold text-sm uppercase tracking-widest mb-3">Tout à gagner</div>
        <h2 className="text-white font-black text-3xl lg:text-4xl mb-4 leading-tight">
          Rejoins maintenant<br />la Méthode <span className="text-[#A3E635]">LS INVEST</span>
        </h2>
        <p className="text-white/60 text-sm mb-8">
          Accès immédiat · 100% gratuit · Sans engagement
        </p>
        <div className="flex flex-col gap-3 max-w-[420px] mx-auto">
          <a
            href="https://luc-saudemont.systeme.io/methode-bourse?utm_source=ig&utm_medium=social&utm_content=link_in_bio&fbclid=PAZXh0bgNhZW0CMTEAc3J0YwZhcHBfaWQMMjU2MjgxMDQwNTU4AAGndKzDJz8CWf8bWLrOB_QQgQl1oJvQD4kziZy3p-jvJhTY02taCKYTVwaewiM_aem_4LGEoEIw_bf1TzxevJOpIw"
            target="_blank"
            rel="noopener noreferrer"
            className="relative overflow-hidden bg-[#F0C932] hover:bg-[#f5d445] text-[#1E0750] font-extrabold text-sm tracking-widest uppercase py-4 px-6 rounded-lg cursor-pointer transition-all whitespace-nowrap text-center block cta-shimmer"
          >
            Je veux à la méthode LS INVEST →
          </a>
          <p className="text-white/30 text-xs text-center">
            🔒 Tes données sont sécurisées et ne seront jamais partagées.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CTAFinal;
